import { Button, Flex, Grid, Space, Typography } from "antd";
import { format, isValid } from "date-fns";

const { useBreakpoint } = Grid;
const { Text } = Typography;

export default function DeliverySettingsMenuSync({
  deliveryService,
  defaultSetting,
  store,
  menuSyncing,
  handleSync
}) {
  const screens = useBreakpoint();

  return (
    <Flex
      justify={screens.md ? "space-between" : undefined}
      align={screens.md ? "end" : "start"}
      vertical={screens.md ? false : true}
      gap={screens.md ? undefined : "large"}
    >
      <Space>
        <Space.Compact direction="vertical">
          <Space>
            <Text strong style={{ fontSize: "18px", margin: 0, lineHeight: 1 }}>Sync Requested:</Text>
            <Text>
              {store.deliverySettings?.[deliveryService]?.menuSync.syncEnd &&
                isValid(
                  store.deliverySettings?.[deliveryService]?.menuSync.syncEnd,
                )
                ? format(
                  store.deliverySettings?.[deliveryService]?.menuSync.syncEnd,
                  "MMM dd yyyy hh:mm a",
                )
                : null}
            </Text>
          </Space>
          <Space>
            <Text strong style={{ fontSize: "16px", margin: 0, lineHeight: 1 }}>Status:</Text>
            <Text>
              {
                store.deliverySettings?.[deliveryService]?.menuSync.status
                  .toLowerCase()
                  .replace(/_/g, ' ')
                  .replace(/\b\w/g, char => char.toUpperCase())
              }
            </Text>
          </Space>
        </Space.Compact>
      </Space>
      <Button
        variant="solid"
        size="large"
        block={screens.md ? false : true}
        style={{
          color: "#FFFFFF",
          background: "#34C759"
        }}
        disabled={
          defaultSetting.enabled === false ||
          menuSyncing ||
          store.deliverySettings?.[deliveryService]?.menuSync.status === "IN_PROGRESS"
        }
        loading={menuSyncing}
        onClick={handleSync}
      >
        {menuSyncing ? "SYNCING..." : "SYNC MENU"}
      </Button>
    </Flex>
  );
};